<div class="w-100 text-center">
  <firebase-ui (signInSuccessWithAuthResult)="onLogInComplete()" *ngIf="!isLoading"></firebase-ui>
  <fa-icon [icon]="['fas', 'spinner']" size="2x" [spin]="true" class="text-center text-muted mt-3" *ngIf="isLoading"></fa-icon>
</div>
